module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/yogasix-1f39cd21aac56fe447676f76f7bb8819.png";